<template>
  <!-- modal -->
  <div
    id="select-modal"
    tabindex="-1"
    aria-hidden="true"
    class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
  >
    <div class="relative p-4 w-full max-w-md max-h-full">

      <!-- content -->
      <div class="relative bg-white rounded-lg shadow-sm">

        <!-- header -->
        <div
          class="flex items-center justify-between p-4 md:p-5 border-b rounded-t border-gray-200"
        >
          <h3 class="text-lg font-semibold text-gray-900 flex">
            <component class="h-7 w-7 text-green-500 mt-auto mb-auto mr-2" :is="PhFileDoc"></component>
            Opções de exportação
          </h3>
          <button
            type="button"
            class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm h-8 w-8 ms-auto inline-flex justify-center items-center"
            data-modal-toggle="select-modal"
          >
            <svg
              class="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span class="sr-only">Close modal</span>
          </button>
        </div>

        <!-- body -->
        <div class="p-4 md:p-5">
          <ul class="space-y-4 mb-4">
            <!-- excel -->
            <li class="anim">
              <input
                type="radio"
                id="job-2"
                name="job"
                value="job-2"
                class="hidden peer"
                @click="generateExcel(itemSelectedReport)"
              />
              <label
                for="job-2"
                class="inline-flex items-center justify-between w-full p-5 text-gray-500 border border-gray-200 rounded-lg cursor-pointer hover:border hover:border-green-500 hover:text-green-500 hover:shadow-lg"
              >
                <!-- labels -->
                <div class="block text-start text-gray-700">
                  <div class="w-full text-lg font-semibold">
                    Exportar como excel (.xlsx, .xls)
                  </div>
                  <div class="w-full text-gray-400">
                    <small>
                      Tenha os dados desse item e suas manutenções realizadas em uma planilha excel
                    </small>
                  </div>
                </div>

                <component class="h-20 w-20  mt-auto mb-auto mr-2" :is="PhFileXls"></component>
              </label>
            </li>

            <!-- pdf -->
            <li class="anim">
              <div class="w-full flex justify-end -mb-6 p-3 pt-0">
                <button
                  class="flex items-center justify-center bg-[#d5f4c9] text-gray-500 py-3 rounded-full mr-4 -mt-1 h-5 w-16 z-20"
                >
                  <small>
                    em breve
                  </small>
                </button>
              </div>
              <input
                type="radio"
                id="job-3"
                name="job"
                value="job-3"
                class="hidden peer"
              />
              <label
                for="job-3"
                class="bg-gray-200 inline-flex items-center justify-between w-full p-5 text-gray-900 border border-gray-200 rounded-lg cursor-not-allowed hover:border hover:border-gray-300"
              >
                <!-- labels -->
                <div class="block text-start">
                  <div class="w-full text-lg font-semibold">
                    Exportar como .pdf
                  </div>
                  <div class="w-full text-gray-500">
                    <small>
                      Exporte os dados desse item em formato pdf para gerar relatórios e ter a ficha cadastral desse item
                    </small>
                  </div>
                </div>

                <component class="h-20 w-20 text-gray-500 mt-auto mb-auto mr-2" :is="PhFilePdf"></component>
              </label>
            </li>

          </ul>
        </div>
      </div>
    </div>
  </div>

  <table
    class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400"
  >
    <thead class="text-xs text-gray-700 uppercase bg-gray-50">
      <tr>
        <slot name="head" />
      </tr>
    </thead>

    <tbody>
      <tr
        v-for="(row, index) in data"
        :key="index"
        class="bg-white border-b hover:bg-gray-50"
      >
        <!-- foto, tipo e função -->
        <th
          scope="row"
          class="flex items-center px-6 py-4 text-gray-900 whitespace-nowrap"
        >
          <!-- foto -->
          <img
            class="w-10 h-10 rounded-full"
            :src="!row['images'] ? defaultImg : imageServe + row['images']"
            :alt="row['name']"
          />

          <!-- tipo -->
          <div class="ps-3">
            <div :title="row['type']" class="text-base font-semibold">
              {{
                row["type"]?.length > 20
                  ? row["type"].slice(0, 20).concat("...")
                  : row["type"]
              }}
            </div>

            <div
              class="font-normal text-gray-500 lowercase"
              :class="[
                row['type'] == 'SISTEMA DE RESGATE' &&
                row?.obs?.kits_sbv.name == 'INADEQUADO'
                  ? 'text-red-600 font-bold'
                  : '',
                row['type'] == 'SISTEMA DE RESGATE' &&
                row?.obs?.kits_sbv.name == 'ADEQUADO'
                  ? 'text-green-600 font-normal'
                  : '',
              ]"
            >
              {{
                row["categoria"]?.length > 20
                  ? row["categoria"].slice(0, 20).concat("...")
                  : row["categoria"]
              }}

              {{
                row["type"] == "EXTINTOR"
                  ? row?.obs?.peso
                  : row["type"] == "HIDRANTE"
                  ? row?.obs?.qtd_mangueira + " mangueiras"
                  : row["type"] == "ACIONADORES E SIRENES"
                  ? "Funcionamento: " + row?.obs?.funcionamento_som?.name
                  : row["type"] == "ILUMINAÇÃO"
                  ? "Funcionamento: " + row?.obs?.funcionamento?.name
                  : row["type"] == "SISTEMA DE RESGATE" &&
                    row?.obs?.kits_sbv.name == "INADEQUADO"
                  ? row?.obs?.kits_sbv_descript?.length > 20
                    ? "Irregular: " +
                      row?.obs?.kits_sbv_descript?.slice(0, 20).concat("...")
                    : "Irregular: " + row?.obs?.kits_sbv_descript
                  : row["type"] == "SISTEMA DE RESGATE"
                  ? row?.obs?.kits_sbv.name
                  : ""
              }}
            </div>
          </div>
        </th>

        <!-- nome e função -->
        <td scope="row" class="px-6 py-4 whitespace-nowrap">
          <div>
            <!-- localização -->
            <div class="text-base font-semibold" :title="row['name']">
              {{
                row["name"]?.length > 20
                  ? row["name"].slice(0, 20).concat("...")
                  : row["name"]
              }}
            </div>

            <div class="font-normal text-gray-500" :title="row['description']">
              {{
                row["description"]?.length > 20
                  ? row["description"].slice(0, 20).concat("...")
                  : row["description"]
              }}
            </div>
          </div>
        </td>

        <!-- status -->
        <td class="px-1 py-4">
          <div class="flex items-center">
            <div
              class="h-2.5 w-2.5 rounded-full me-2"
              :class="[
                row['status'] === 'vencido' ? 'bg-red-500' : '',
                row['status'] === 'a vencer' ? 'bg-yellow-500' : '',
                row['status'] === 'em dia' ? 'bg-green-500' : '',
                row['status'] === 'em cadastro' ? 'bg-yellow-300' : '',
              ]"
            ></div>
            {{ row["status"] }}
          </div>
        </td>

        <!-- vencimento inspeção -->
        <td class="px-6 py-4">
          <div class="flex items-center">
            <div
              class="h-2.5 w-2.5 rounded-full bg-green-500 me-2"
              :class="[
                row['next'] == 'Hoje' ? 'bg-red-500' : '',
                row['next'] == 'não informado' ? 'bg-gray-300' : '',
                row['next'] < 30 ? 'bg-yellow-500' : '',
                row['next'] > 30 ? 'bg-green-500' : '',
              ]"
            ></div>
            {{
              row["next"] !== "Hoje" && row["next"] !== "não informado"
                ? "em " + row["next"] + " dias "
                : row["next"]
            }}
          </div>
        </td>

        <!-- vencimento do TH -->
        <td class="px-6 py-4">
          <div class="flex items-center">
            <div
              class="h-2.5 w-2.5 rounded-full bg-green-500 me-2"
              :class="[
                row['th_expiration'] == null ? 'bg-gray-300' : '',
                formatDate(row['th_expiration']) == 'vencido' ? 'bg-red-500' : '',
                formatDate(row['th_expiration']) == 'a vencer' ? 'bg-yellow-500' : '',
              ]"
            ></div>
            {{
              row["th_expiration"]
                ? formatDate(row["th_expiration"])
                : "não informado"
            }}
          </div>
        </td>

        <!-- ações -->
        <td class="px-6 py-4">
          <div class="flex justify-center font-medium">
            <!-- Editar dados -->
            <a
              title="Editar registro"
              class="text-yellow-600 mr-1 hover:underline cursor-pointer"
              @click="setComponentActive(UpdateAndMaintenanceForm, row['id'])"
            >
              <component :is="PhNotePencil" class="h-6 w-6" />
            </a>

            <!-- Relatório -->
            <button
              title="Gerar relatório"
              data-modal-target="select-modal"
              data-modal-toggle="select-modal"
              class="block font-medium rounded-lg text-sm text-center text-green-600 mr-1 cursor-pointer"
              type="button"
              @click="setItem(row['id'])"
            >
              <component :is="PhFileDoc" class="h-6 w-6" />
            </button>

            <!-- Remover documento -->
            <a
              title="Remover registro"
              class="text-red-600 mr-1 hover:underline cursor-pointer"
              @click="deleteItem(row['id'], row['sector_id'])"
            >
              <component :is="PhTrash" class="h-6 w-6" />
            </a>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
import UpdateAndMaintenanceForm from '../../layout/pages/UpdateAndMaintenanceForm.vue'
import ExtinguisherService from '../../service/extinguisher.service'
import moment from 'moment'
import { PhFileDoc, PhFilePdf, PhFileXls, PhNotePencil, PhTrash } from '@phosphor-icons/vue'
import { showToast as toast } from '@/helpers/UseToasts'
import { dataExtinguisher } from '../../store'
import { initFlowbite } from 'flowbite'
import { storeApp } from '@/store'
import { defineProps, onMounted, markRaw, ref } from 'vue'

const itemSelectedReport = ref(undefined)
const store = dataExtinguisher.state
const imageServe = process.env.VUE_APP_IMAGE_SERVE + 'storage/'
const defaultImg = require('@/assets/logo/icon.png')
const props = defineProps({
  data: [Object, Array]
})

const emit = defineEmits(['delete'])

const setItem = (id) => {
  itemSelectedReport.value = id
}

function formatDate (date) {
  const today = moment().startOf('day')
  const exTh = moment(date, 'YYYY-MM-DD').startOf('day')
  const limit = today.clone().add(30, 'days')

  if (exTh.isBefore(today) || exTh.isSame(today, 'day')) {
    return 'vencido'
  }

  if (exTh.isSameOrBefore(limit)) {
    return 'a vencer'
  }

  return exTh.format('DD/MM/YYYY')
}

function deleteItem (id, sectorId) {
  emit('delete', { id, sectorId })
}

async function setComponentActive (value, itemId) {
  // dataExtinguisher.dispatch("setPageSubTitle", "Registre um novo setor para gerenciar seus itens");
  storeApp.state.loading = true

  // pega os dados do item para alteração

  await ExtinguisherService.getItenById(itemId)
    .then((res) => {
      dataExtinguisher.dispatch('resetForm')

      delete res.data.created_at
      delete res.data.updated_at
      delete res.data.deleted_at

      dataExtinguisher.dispatch('setItemToEdit', res.data)

      storeApp.state.loading = false

      store.itensForm.imagesName = res.data.images
      store.itensForm.oldImage = res.data.images
    })
    .catch((err) => {
      storeApp.state.loading = false

      if (err?.response?.data?.error && err.response.data.status === 400) {
        return toast('Aviso', err.response.data.message, 'error')
      }

      return toast(
        'Aviso',
        'Algo deu errado ao buscar dados do item',
        'error'
      )
    })

  dataExtinguisher.dispatch('setComponentActive', markRaw(value))
}

function generateExcel (id) {
  emit('export-excel', id)
}

onMounted(() => {
  initFlowbite()
})
</script>

<style lang="scss">
.anim {
  transition-duration: .5s;

  &:hover {
    transform: translateY(-5px);
    transition-duration: 0.3s;
  }
}
</style>
